export default {
      id: "ic_heart_empty-usage",
      viewBox: "0 0 19 18",
      url: "/" + "images/icons.3.109.2.svg#ic_heart_empty-usage",
      toString: function () {
        return this.url;
      }
    }